import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, SurflineLogo } from '@surfline/quiver-react';
import config from '../../config';
import en from '../../international/translations/en';
import { trackPerkEvents } from '../../utils/trackPerkEvents';

const brandName = { sl: 'Surfline', bw: 'Buoyweather', fs: 'FishTrack' };

const getCTAClass = planType => classNames({
  'header-right__item': true,
  'header-right__item--free': planType === 'free',
});

const getTitleText = (planType, eligibleCount) => {
  if (!planType) {
    return {
      title: 'We’ve partnered with your favorite brands to save you up to 40%.',
      subtitle: null,
      buttonText: 'GO PREMIUM'
    };
  }
  if (planType.includes('monthly')) {
    return {
      title: 'We’ve partnered with your favorite brands to save you up to 40%.',
      subtitle: `Subscribers on a yearly subscription have immediate access to Premium Perks. If you stay on your monthly plan, you can access perks after your ${eligibleCount}rd month of membership.`,
      buttonText: 'SWITCH TO YEARLY'
    };
  }
  return {
    title: 'We’ve partnered with your favorite brands to save you up to 40%.',
    subtitle: null,
    buttonText: 'GO PREMIUM'
  };
};

const handleButtonClick = (planType) => {
  trackPerkEvents(planType, { perkId: null, perkName: null });
  if (planType === 'monthly') return window.location.assign(en.perks.monthlyRedirectUrl);
  return window.location.assign(en.perks.freeRedirectUrl);
};

const PerkCTA = ({ planType, eligibleCount }) => (
  <div className={getCTAClass(planType)}>
    <div className="header-right__text">
      <div className="header-right__title">{getTitleText(planType, eligibleCount).title}</div>
      <div className="header-right__sub-text">{getTitleText(planType, eligibleCount).subtitle}</div>
    </div>
    <div className="header-right__button">
      <Button onClick={() => handleButtonClick(planType)}>
        {getTitleText(planType).buttonText}
      </Button>
    </div>
  </div>
);

const PerksHeader = ({
  isCommonEligible,
  planType,
  eligibleCount,
}) => (
  <div>
    <div className="perks-header--menu">
      <div className="menu--logo">
        <a href="/">
          <SurflineLogo />
        </a>
      </div>
      <div className="menu--account">
        {
          planType !== 'free' ?
            <a href="/account"><div>MY ACCOUNT</div></a>
            :
            null
        }
      </div>
    </div>
    <div className="perks-header">
      <div className="header-left__item">
        <div className="perks-header__text">Premium Perks</div>
        <div className="perks-header__sub-text">
          {brandName[config.company]} Premium members score exclusive discounts on boards, gear, and travel.
        </div>
      </div>
      {!isCommonEligible ?
        <PerkCTA planType={planType} eligibleCount={eligibleCount} />
        :
        <div className="header-right__item--premium" />
      }
    </div>
  </div>

);

PerksHeader.propTypes = {
  isCommonEligible: PropTypes.bool,
  planType: PropTypes.string,
  eligibleCount: PropTypes.number,
};
PerksHeader.defaultProps = {
  isCommonEligible: null,
  planType: null,
  eligibleCount: null,
};

export default PerksHeader;

